import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  setCommunicationBoardError,
  updateCommunicationBoardData,
} from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSlice'
import { useTranslation } from 'react-i18next'
import { selectAuthData } from '@/containers/Login/AuthSelectors'

const useCommunicationBoardEventListener = shouldLoad => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { country } = useSelector(selectAuthData)

  useEffect(() => {
    if (!country) return

    const channelName = `communication-board.${country}`
    const channel = window.Echo.channel(channelName)

    channel.listen('.operation.success', e => {
      if (!e?.data?.sections) return
      dispatch(
        updateCommunicationBoardData({
          sections: e.data.sections || [],
          error: null,
        }),
      )
    })

    channel.listen('.operation.failed', e => {
      dispatch(setCommunicationBoardError(e.error || t('common:fetching_error')))
    })

    return () => {
      channel.stopListening('.operation.success')
      channel.stopListening('.operation.failed')
      window.Echo.leaveChannel(channelName)
    }
  }, [country, dispatch])
}

export default useCommunicationBoardEventListener
